import BrButton from '@govbr/react-components/lib/BrButton';
import { useAppSelector } from '../../../app/hooks';
import erroIndicativoNascimento from '../../../assets/img/erro-indicativo-nascimento.png';
import { selectIntegranteIndicativoNascimento } from '../indicativoNascimentoSlice';
import styles from '../IndicativoNascimentoErro/IndicativoNascimentoErro.module.css';

interface Props {
  onFechar: () => void;
}

const IndicativoNascimentoErroHorario: React.FC<Props> = ({ onFechar }) => {
  const integrante = useAppSelector(selectIntegranteIndicativoNascimento);
  const nomeCompleto = integrante?.nome?.toUpperCase() ?? '';

  return (
    <div className={styles.container}>
      <div className={styles.imagemWrapper}>
        <img className={styles.imagem} src={erroIndicativoNascimento} alt="Erro ao incluir integrante" />
      </div>
      <div className={styles.conteudo}>
        <p className={styles.textoPrincipal}>
          Não foi possível incluir o {nomeCompleto} no cadastro da sua família.
        </p>
        <p className={styles.textoSecundario}>
          O horário permitido para a inclusão de novos integrantes na família é entre{' '}
          <strong>7h e 19h (horário de Brasília)</strong>.
        </p>
        <BrButton className={styles.botaoFechar} onClick={onFechar}>
          Fechar
        </BrButton>
      </div>
    </div>
  );
};

export default IndicativoNascimentoErroHorario;
